import { Button, Col, Form, Input, Row } from '@sinohealth/butterfly-ui-components/lib';
import React from 'react';

const SearchForm: React.FC = (props: any = {}) => {
  return (
    <Form labelAlign="right" colon={false} {...props}>
      <Row gutter={[120, 24]}>
        <Col span={8} style={{ paddingRight: 0 }}>
          <Form.Item name="piecesCode" label="中药饮片代码：">
            <Input placeholder="请输入中药饮片代码" />
          </Form.Item>
        </Col>
        <Col span={8} style={{ paddingRight: 0 }}>
          <Form.Item name="piecesName" label="中药饮片名称：">
            <Input placeholder="请输入中药饮片名称" />
          </Form.Item>
        </Col>
        <Col span={8} style={{ textAlign: 'right' }}>
          <Button
            onClick={() => {
              props.form.resetFields();
              props.form.submit();
            }}
          >
            重置
          </Button>
          &nbsp; &nbsp;
          <Button type="primary" htmlType="submit">
            查询
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default SearchForm;
